import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { LoadingSpinner } from "@/components/loading/LoadingSpinner";
import PageError from "@/components/page-error";

const PriceMarkdownOverviewPage = lazy(() => import("./overview"));

const PriceMarkdownDrillPage = lazy(() => import("./selection/drill-page"));

export default function PriceMarkdownRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="overview" replace />} />
      <Route
        path="/overview"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <PriceMarkdownOverviewPage />
          </Suspense>
        }
      />
      <Route
        path="/selecao/drill/:remarcacaoId"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <PriceMarkdownDrillPage />
          </Suspense>
        }
      />
      <Route path="/cartas/gerar" element={<Navigate to="../cartas" replace />} />
      <Route
        path="*"
        element={<PageError status={400} message={"PÁGINA NÃO ENCONTRADA"} />}
      />
    </Routes>
  );
}
